import { ReactElement } from "react";
import { useLocation } from "react-router-dom";
import { TabNavLinkPropsType } from "./TabNavLink";
import './Tabs.scss';
import { resolveRoute } from "config/router";

type TabNavPropsType = {
    alt?: boolean;
    children?: ReactElement<TabNavLinkPropsType>[]
}

const TabNav = (props: TabNavPropsType) => {
    const location = useLocation();
    const onClick = (e: React.MouseEvent) => {
        const link = e.currentTarget.children[0] as HTMLLinkElement;
        link.click();
    }

    const canShow = (tab: ReactElement<TabNavLinkPropsType>) => {
        if(tab.props.hidden === true || (typeof tab.props.hidden === 'function' && tab.props.hidden() === true)) return false;
        return true;
    }

    const machUrl = (tab: TabNavLinkPropsType) => {
        if(!tab.match) {
            const path = resolveRoute(tab.to, tab.params);
            return location.pathname === path;
        }

        if(typeof tab.match == 'function') {
            return tab.match(location.pathname);
        } else if(typeof tab.match == "string") {
            return location.pathname === tab.match;
        } else {
            return tab.match.test(location.pathname);
        }
    }

    return (
        <nav className={`tab-nav${props.alt ? ' alt' : ''}`}>
            <ul>
                {props.children!.filter(c => canShow(c)).map((c: ReactElement<TabNavLinkPropsType>) => {
                    return (
                        <li onClick={e => onClick(e)} key={c.props.to} className={`${machUrl(c.props) ? 'active' : ''}`}>
                            {c}
                        </li>
                    )   
                })}
            </ul>
        </nav>
    );
};

export default TabNav;
